import { render, staticRenderFns } from "./RoomSaleMain.vue?vue&type=template&id=46d30fb8"
import script from "./RoomSaleMain.vue?vue&type=script&lang=js"
export * from "./RoomSaleMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports